import { Box, Container } from '@mui/material'
import RegisterAccess from '../../../../utils/registerAccess';
import HeaderSession from '../../../../utils/headerSession';
import CardOpcoes from '../../../../utils/cardOpcoes';

const useStyles = (theme) => ({

    containerCardesService: {
        padding: '2rem',
        display: 'flex',
        flexWrap: 'wrap',
        //  flexDirection: 'wrap',
        /* ALINHAR OS ITENS NA HORIZONTAL E NA VERTIVACL */
        justifyContent: 'center',
        alignItems: 'center',
        /* AFASTAR UM ITEM DO OUTRO */
        gap: '1rem',
    }

});

export default function FarmacovigilanciaOPC() {
    const classes = useStyles()
    return (
        <Container style={{ minHeight: '70vh', maxWidth: 800 }}>
            <RegisterAccess page={'farmacovigilancia'} />
            <HeaderSession title='FARMACOVIGILÂNCIA' />

            <Box style={classes.containerCardesService}>
                <CardOpcoes disabled={false} nomeService={'Ficha De Notificação De Produtos De Baixa Qualidade'} link={'/farmacovigilancia/ficha-de-notificacao-de-produtos-com-baixa-qualidade'} />
                <CardOpcoes disabled={false} nomeService={'Ficha De Notificação De Suspeita De Reações Adversas a Medicamentos e Produtos'} link={'/farmacovigilancia/ficha-de-notificacao-de-suspeita-de-reacoes-adversas-a-medicamentos-e-produtos'} />
            </Box>
        </Container>

    )
}